<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<mat-form-field class="new-exp-form-field">
  <mat-label>{{groupLabel}}</mat-label>
  <mat-select [formControl]="selectedMembersControl" multiple>
    <mat-select-trigger>
      <mat-chip-set>
        <mat-chip *ngFor="let member of selectedMembersControl.value"
          [removable]="true" (removed)="removeMember(member)"
          >{{member}}<mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-set>
    </mat-select-trigger>
    <mat-option *ngFor="let member of membersList" [value]="member">{{member}}</mat-option>
  </mat-select>
</mat-form-field>
